import { RecordType } from '@/components/shared/DeleteRecordModal'
import { extractFileNameFromUrl } from '@/utils/parsers'
import Attachment from '@/types/Attachment'
import { DeleteRecordButton } from '@/components/DeleteRecordButton'

export type onAttachmentDeletedCallback = (attachment: Attachment) => void

interface AttachmentProps {
  attachment: Attachment,
  onAttachmentDeleted?: onAttachmentDeletedCallback
}

export default function AttachmentControl({
  attachment,
  onAttachmentDeleted,
}: AttachmentProps) {

  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="text-muted small">{extractFileNameFromUrl(attachment.url)}</div>
      <DeleteRecordButton
        recordType={RecordType.Attachment}
        recordIdOrSlug={attachment.id}
        onDeleted={() => onAttachmentDeleted?.(attachment)}
        iconButton
      />
    </div>
  )
}
